export default "__VITE_ASSET__E0X5T33v__"